/* Qik Joe — product gallery

   Some of these products carry sixty-odd images: the front, the back panel,
   the directions, coverage tables, size comparisons. Showing one of them would
   hide most of what a buyer needs to read before spending money on a pallet.

   Thumbnails are buttons in a scrollable strip. Selecting one swaps the main
   image rather than navigating, and arrow keys move along the strip the way
   they do in any other set of related controls. */

(function () {
  'use strict';

  function Gallery(root) {
    this.main = root.querySelector('[data-gallery-main]');
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    if (!this.main || this.thumbs.length < 2) return;

    this.counter = root.querySelector('[data-gallery-counter]');
    this.index = 0;
    var self = this;

    this.thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { self.show(i, true); });
      btn.addEventListener('keydown', function (e) { self.onKey(e, i); });
    });

    this.show(0, false);
  }

  Gallery.prototype.onKey = function (event, i) {
    var last = this.thumbs.length - 1;
    var next = null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = i >= last ? 0 : i + 1;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = i <= 0 ? last : i - 1;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = last;
    if (next === null) return;
    event.preventDefault();
    this.show(next, true);
    this.thumbs[next].focus();
  };

  Gallery.prototype.show = function (i, scroll) {
    this.index = i;
    var btn = this.thumbs[i];
    var img = btn.querySelector('img');
    if (!img) return;

    var full = btn.getAttribute('data-gallery-full') || img.currentSrc || img.src;
    this.main.src = full;
    this.main.alt = img.alt || '';

    // srcset on the main image would keep serving the previous product photo
    // at some widths, so it is cleared when the source changes.
    this.main.removeAttribute('srcset');

    for (var t = 0; t < this.thumbs.length; t++) {
      var on = t === i;
      this.thumbs[t].classList.toggle('is-current', on);
      this.thumbs[t].setAttribute('aria-selected', on ? 'true' : 'false');
      this.thumbs[t].setAttribute('tabindex', on ? '0' : '-1');
    }

    if (this.counter) this.counter.textContent = (i + 1) + ' / ' + this.thumbs.length;
    if (scroll && btn.scrollIntoView) {
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  };

  function init(root) {
    var nodes = (root || document).querySelectorAll('[data-gallery]');
    for (var i = 0; i < nodes.length; i++) new Gallery(nodes[i]);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
